<template>
  <a-modal
    v-model="dialogVisible"
    :title="title"
    width="928px"
    :mask-closable="false"
    class="import-dialog"
    :ok-button-props="{ props: { disabled: !uploadFileInfo.name } }"
    @ok="confirmImport"
  >
    <div class="import-dialog-body">
      <!-- 左侧模板下载 -->
      <div class="body-left body-section">
        <div class="body-section-title">
          <span class="body-section-title_index">1</span>
          {{ tipFirst }}
        </div>
        <div class="body-section-content">
          <img
            :src="require('@/assets/images/purchaser/inquiry/icon-excel.png')"
            style="width: 50px; height: 50px"
          />
          <p class="m-t-16 m-b-24">{{ templateName }}</p>
          <slot name="download">
            <a-button
              type="primary"
              style="width: 64px"
              @click="downloadTemplate"
            >
              下载
            </a-button>
          </slot>
        </div>
      </div>
      <a-divider
        type="vertical"
        style="height: auto; color: #eaeaea; margin: 0 24px"
      />
      <!-- 右侧文件上传 -->
      <div class="body-right body-section">
        <div class="body-section-title">
          <span class="body-section-title_index">2</span>
          {{ tipSecond }}
        </div>
        <div class="body-section-content">
          <img
            :src="require(`@/assets/images${templateIcon}`)"
            style="width: 50px; height: 50px"
          />
          <p class="m-t-16 m-b-24">
            请使用下载的模板表格格式上传文件，仅支持上传1份文件
          </p>
          <div class="upload-button m-r-10" @click="handleImport">
            <a-button style="width: 88px" type="primary">上传文件</a-button>
            <input
              v-show="false"
              ref="fileupload"
              type="file"
              name="fileupload"
              :value="uploadFile"
              @change.stop="fileChange"
            />
          </div>
        </div>
        <div v-if="uploadFileInfo.name" class="m-t-16 flex row-between">
          <span>{{ uploadFileInfo.name }}</span>
          <span style="cursor: pointer" @click="removeFile">
            <i class="el-icon-close"></i>
          </span>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'TemplateImportDialog',

  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: '采购清单导入'
    },

    tipFirst: {
      type: String,
      default: '下载品目模板，根据所提供的模板编辑模板表格'
    },

    tipSecond: {
      type: String,
      default: '上传表格，点击确认完成采购清单导入'
    },

    templateName: {
      type: String,
      default: '品目模板.xlsx'
    },

    templateIcon: {
      type: String,
      default: '/purchaser/inquiry/icon-file-box.png'
    }
  },

  data() {
    return {
      uploadFile: '', // 上传的文件
      uploadFileInfo: {}
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  methods: {
    /**
     * 下载模板
     */
    downloadTemplate() {
      this.$emit('download')
    },

    /**
     * 批量导入
     */
    handleImport() {
      this.$refs.fileupload.click()
    },

    fileChange(e) {
      const fileList = Array.from(e.currentTarget.files)

      if (!fileList[0]) {
        return false
      }

      this.$refs.fileupload.value = ''

      this.uploadFileInfo = fileList[0]
      this.$emit('upload', fileList[0])
    },

    /**
     * 删除导入数据
     */
    removeFile() {
      this.uploadFileInfo = {}
      this.uploadFile = null
      this.$emit('remove')
    },

    /**
     * 确认导入
     */
    confirmImport() {
      this.dialogVisible = false
      this.uploadFileInfo = {}
      this.uploadFile = null
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
.import-dialog {
  ::v-deep .ant-modal-body {
    padding: 40px 24px;
  }

  .import-dialog-body {
    display: flex;
    align-items: stretch;

    .body-section {
      flex: 1;
      padding-bottom: 4px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;

      .body-section-title {
        font-size: 16px;
        color: $text-color;
        @include text-bold;
        display: flex;
        align-items: flex-start;

        .body-section-title_index {
          display: inline-block;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          font-weight: normal;
          color: $white-color;
          background-color: $primary-color;
          text-align: center;
          line-height: 22px;
          margin-right: 8px;
        }
      }

      .body-section-content {
        width: 100%;
        border: 1px dashed $info-second-color;
        border-radius: 4px;
        padding: 30px 16px;
        text-align: center;
        margin-top: 32px;

        p {
          color: $text-color;
        }
      }
    }
  }
}
</style>
